import { useMemo } from 'react'
import { useQueryResponse } from '../core/QueryResponseProvider'
import { useQueryRequest } from '../core/QueryRequestProvider'
import { useListFilters } from '../core/ListFiltersProvider'
import { CustomTable, TableEmptyState } from '../../../../../components'
import { FaturaProfissionalDtoList } from '../core/_models'
import { faturaProfissionalColumns } from './columns/_columns'
import { useT } from '_metronic/i18n/Metronici18n'

export const FaturaProfissionalTable = () => {
  const { isLoading, isError, refetch, response } = useQueryResponse()
  const { hasFilters, clearFilters } = useListFilters()
  const { t } = useT()

  const columns = useMemo(() => faturaProfissionalColumns(t), [t])

  const emptyState = hasFilters ? (
    <TableEmptyState
      title='Nenhuma fatura encontrada'
      description='Revise a instituição e o período.'
      action={{ label: 'Limpar filtros', onClick: clearFilters }}
    />
  ) : (
    <TableEmptyState
      title='Nenhuma fatura ainda'
      description='Suas faturas aparecem aqui quando os atendimentos forem faturados.'
    />
  )

  return (
    <CustomTable<FaturaProfissionalDtoList>
      id='kt_table_profissional_faturas'
      ariaLabel={t('menu.minhas_faturas')}
      itemLabel={{ singular: 'fatura', plural: 'faturas' }}
      data={response?.data || []}
      columns={columns}
      isLoading={isLoading}
      isError={isError}
      onRetry={refetch}
      emptyState={emptyState}
      queryHooks={{ useQueryRequest, useQueryResponse }}
    />
  )
}
